import {
  GET_PAYMENTS,
  GET_PAYMENT_DEBITS,
  ONLINE_PAYMENT_INFO,
  UPSERT_PAYMENT,
} from '../../actions/payments';

const paymentsReducer = (state = {}, action = {}) => {
  const {
    type = '',
    paymentsData = {},
    paymentInfo = {},
    paymentDebitsData = {},
  } = action;

  switch (type) {
    case UPSERT_PAYMENT.INITIATE:
      return {
        ...state,
      };
    case UPSERT_PAYMENT.SUCCESS:
      return {
        ...state,
      };
    case UPSERT_PAYMENT.FAILED:
      return {
        ...state,
      };
    case GET_PAYMENTS.INITIATE:
      return {
        ...state,
      };
    case GET_PAYMENTS.SUCCESS:
      return {
        ...state,
        paymentsData,
      };
    case GET_PAYMENTS.FAILED:
      return {
        ...state,
      };
    case ONLINE_PAYMENT_INFO.INITIATE:
      return {
        ...state,
      };
    case ONLINE_PAYMENT_INFO.SUCCESS:
      return {
        ...state,
        paymentInfo,
      };
    case ONLINE_PAYMENT_INFO.FAILED:
      return {
        ...state,
      };
    case GET_PAYMENT_DEBITS.INITIATE:
      return {
        ...state,
      };
    case GET_PAYMENT_DEBITS.SUCCESS:
      return {
        ...state,
        paymentDebitsData,
      };
    case GET_PAYMENT_DEBITS.FAILED:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default paymentsReducer;
